import { render, staticRenderFns } from "./EditConfigs.vue?vue&type=template&id=1e8c2aed&"
import script from "./EditConfigs.vue?vue&type=script&lang=js&"
export * from "./EditConfigs.vue?vue&type=script&lang=js&"
import style0 from "./EditConfigs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports